module.exports = __webpack_public_path__ + "static/img/basketball.2bdd97d.jpg";